(function (Wishlist, $) {
  var $wishlistButton = $(".wishlist-btn");
  var $wishlistTile = $(".wishlist-tile-container");
  var $wishlitcounter = $(".wishlist-counter");
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem("user_wishlist") || [];
  var wishlistExtra = localStorage.getItem("user_wishlist_extra") || [];
  var wishlist_count_set = localStorage.getItem("user_wishlist_count");
  if (wishlist_count_set == null) {
    var wishlist_count = "0";
    $wishlitcounter.html(wishlist_count);
  } else {
    $wishlitcounter.html(wishlist_count_set);
  }
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem("user_wishlist"));
    wishlistExtra = JSON.parse(localStorage.getItem("user_wishlist_extra")) || [];
  }

  /*
   * Update button to show current state (gold for active)
   */
  var animateWishlist = function (self) {
    $(self).toggleClass("is-active");
  };

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */
  var updateWishlist = function (self) {
    var productHandle = $(self).attr("data-product-handle");
    var isRemove = $(self).hasClass("is-active");
    var wishlist_value = localStorage.getItem("user_wishlist_count");

    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlistExtra = wishlistExtra.filter(function (p) {
        return p.productHandle !== productHandle;
      });

      wishlist.splice(removeIndex, 1);

      var wishlist_count = localStorage.getItem("user_wishlist_count");

      if (wishlist_count != null) {
        var minus_val = -1;
        var wish_ct = Math.max(parseInt(wishlist_count) + minus_val, 0);

        localStorage.setItem("user_wishlist_count", wish_ct);
      }
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      localStorage.setItem("user_wishlist_extra", JSON.stringify(wishlistExtra));
      var icon_length = $(self).find("span").length;

      if (icon_length != 0 && attr != "product") {
        $wishlistButton.html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
      }
      var wishlist_count_value = localStorage.getItem("user_wishlist_count");
      $wishlitcounter.html(wishlist_count_value);
      $('.wishlist-tile-container[data-product-handle="' + productHandle + '"]').fadeOut();
    } else {
      /* Add */
      wishlist.push(productHandle);
      let variant = getUrlParameter("variant");
      if (variant) {
        wishlistExtra.push({ productHandle: productHandle, variant: variant });
      }

      var wishlist_count = localStorage.getItem("user_wishlist_count");
      if (wishlist_count == null) {
        var plus_val = 1;
        var wish_ct = plus_val;
      } else {
        var plus_val = 1;
        var wish_ct = Math.max(parseInt(wishlist_count) + plus_val, 0);
      }
      localStorage.setItem("user_wishlist_count", wish_ct);
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
      localStorage.setItem("user_wishlist_extra", JSON.stringify(wishlistExtra));

      var icon_length = $(self).find("span").length;

      ///alert(icon_length);
      if (icon_length != 0 && attr != "product") {
        $wishlistButton.html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
      }
      var wishlist_count_value = localStorage.getItem("user_wishlist_count");
      //alert(wishlist_count_value)
      $wishlitcounter.html(wishlist_count_value);
    }
    //console.log(JSON.stringify(wishlist));
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr("data-product-handle");
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass("is-active");
        var icon_length = $(this).find("span").length;
        if ($(this).hasClass("is-active")) {
          if (icon_length != 0 && attr != "product") {
            $(this).html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
          }
        } else {
          if (icon_length != 0 && attr != "product") {
            $(this).html('<span class="add-wishlist"><i class="bi bi-heart"></i></span><span class="loading-wishlist animated infinite rotateOut"><i class="bi bi-brightness-high"></i></span><span class="remove-wishlist"><i class="bi bi-x"></i></span>');
          }
        }
      }
    });
  };

  var displayOnlyWishlistItems = function () {
    numProductTiles = wishlist.length;
    $.ajaxSetup({ async: false });
    let i = 0;
    const template = document.querySelector("#product-template");
    const canvas = document.querySelector("#canvas-products");
    while (i < wishlist.length) {
      const clone = template.content.cloneNode(true);
      var variant = wishlistExtra
        .filter(function (p) {
          return p.productHandle == wishlist[i];
        })
        .shift();

      var productData = clone.querySelector("#product-data"),
        productUrl = clone.querySelector("#product-url"),
        productLink = clone.querySelector("#product-link"),
        productImage = clone.querySelector("#product-image"),
        productAddToCart = clone.querySelector("#product-add-cart"),
        productRemove = clone.querySelector("#product-item-remove");

      $.getJSON(window.Shopify.routes.root + "products/" + wishlist[i] + ".js", function (product) {
        let variantId, targetUrl;

        if (variant) {
          variantId = variant.variant;
          targetUrl = product.url + "?variant=" + variantId;
        } else {
          variantId = product.variants[0].id;
          targetUrl = product.url;
        }

        productData.setAttribute("data-product-id", product.id);
        productData.setAttribute("data-product-handle", product.handle);

        productUrl.href = targetUrl;

        productLink.href = targetUrl;
        productLink.title = product.title;
        productLink.textContent = product.title;

        productImage.src = product.featured_image;
        productImage.alt = product.title;
        
        productAddToCart.href = product;
        productAddToCart.setAttribute("onclick", `Shopify.addItem(${variantId} , 1); return false;`);

        productRemove.setAttribute("data-product-handle", product.handle);
      });

      canvas.appendChild(clone);
      i++;
    }
    $wishlistButton = $(".wishlist-btn");
    bindUIActions();
    $.ajaxSetup({ async: true });
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */
  var loadWishlist = function () {
    if (window.location.href.indexOf("pages/wishlist") > -1) {
      displayOnlyWishlistItems();
      $(".wishlist-loader").fadeOut(2000, function () {
        $(".wishlist-grid").addClass("is_visible");
        $(".wishlist-hero").addClass("is_visible");
        if (numProductTiles == 0) {
          $(".wishlist-grid-empty-list").addClass("is_visible");
          $(".wishlist-grid").hide();
        } else {
          $(".wishlist-grid-empty-list").hide();
        }
      });
    }
  };

  var bindUIActions = function () {
    $wishlistButton.on('click', function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    loadWishlist();
  };

  // Remove All Items..
  $("#remove-done").click(function () {
    var raw = localStorage.getItem("user_wishlist");
    var length = raw.length;
    var i;
    var productHandle = $(self).attr("data-product-handle");
    var isRemove = $(self).hasClass("is-active");

    /* Remove */
    for (i = length - 1; i >= 0; i--) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      var wishlist_count = localStorage.getItem("user_wishlist_count");
      //alert(wishlist_count);
      if (wishlist_count != null) {
        var wish_ct = Math.max(parseInt(0), 0);
        localStorage.setItem("user_wishlist_count", wish_ct);
      }
      localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
    }
    location.reload(true);
  });
})((window.Wishlist = window.Wishlist || {}), jQuery, undefined);

function reloadPage() {
  location.reload(true);
}
